export default "__VITE_ASSET__CGfiZX6R__"